import { ActionInterface } from "../interfaces/Actions.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_ACTION: ActionInterface = {
	id: "",
	message_enum: 0,
	lift_type: "ELEVATOR",
	target_position: 0,
	label: "",
	valid_states: [],
	tooltip: "",
};

export const ELEVATOR_CONTROLS = [
	{ name: "CarCallLock", id: 0 },
	{ name: "CarCallUnlock", id: 1 },
	{ name: "RearCarCallLock", id: 2 },
	{ name: "RearCarCallUnlock", id: 3 },
	{ name: "UpHallCallLock", id: 4 },
	{ name: "UpHallCallUnlock", id: 5 },
	{ name: "UpRearHallCallLock", id: 6 },
	{ name: "UpRearHallCallUnlock", id: 7 },
	{ name: "UpAssignedHallCall", id: 8 },
	{ name: "UpAssignedRearHallCall", id: 9 },
	{ name: "DownHallCallLock", id: 10 },
	{ name: "DownHallCallUnlock", id: 11 },
	{ name: "DownRearHallCallLock", id: 12 },
	{ name: "DownRearHallCallUnlock", id: 13 },
	{ name: "DownAssignedHallCall", id: 14 },
	{ name: "DownAssignedRearHallCall", id: 15 },
	{ name: "EnergizeCarCall", id: 16 },
	{ name: "EnergizeRearCarCall", id: 17 },
	{ name: "EnergizeUpHallCall", id: 18 },
	{ name: "EnergizeUpRearHallCall", id: 19 },
	{ name: "EnergizeDownHallCall", id: 20 },
	{ name: "EnergizeDownRearHallCall", id: 21 },
	{ name: "SecureCarCall", id: 22 },
	{ name: "SecureRearCarCall", id: 23 },
	{ name: "VIP", id: 24 },
	{ name: "OpenDoor", id: 25 },
	{ name: "CloseDoor", id: 26 },
];
